var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ball-pulse-sync loader",class:{ [_vm.size]: true, [_vm.color]: true }},_vm._l((3),function(index){return _c('div',{key:index})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }